/**
 * Which pages are READ-ONLY at which enquiry status (Akhil, 2026-09-16).
 *
 *   Quotation Sent          the RFQ builder — the customer has the quotation, so re-triaging lines
 *                           or mailing suppliers again is not the work any more; changes to what
 *                           the customer sees belong on the quotation and revision pages.
 *   Won / Rejected / Archived
 *                           every page — the enquiry is decided and each screen is now a record
 *                           of how it was priced, not a place to price it.
 *
 * A guard in the UI, not enforcement: the server does not refuse writes by status (an ask). The
 * pages apply it through `components/ReadOnlyGate`, which disables every control inside it at
 * once — so a button added next month is covered without anyone remembering this file.
 */

import type { EnquiryStatus } from './types'

export type LockablePage = 'rfq' | 'suppliers' | 'compare' | 'quote' | 'revisions'

const DECIDED: ReadonlySet<EnquiryStatus> = new Set<EnquiryStatus>(['Won', 'Rejected', 'Archived'])

/** The banner text when the page is locked at this status; `null` when it is editable. */
export function lockReason(status: EnquiryStatus, page: LockablePage): string | null {
  if (DECIDED.has(status)) return `Read-only — this enquiry is ${status}. Every page is now a record of how it was priced.`
  if (status === 'Quotation Sent' && page === 'rfq') {
    return 'Read-only — the quotation has gone to the customer. Changes to it are made on the quotation and revision pages.'
  }
  return null
}
